// Открывает внешний URL: в RN-вебвью кидает postMessage хосту,
// иначе window.open в новой вкладке.
export default function openExternalUrl(url) {
  if (!url) return;
  if (typeof window !== "undefined" && window.isRNWebView) {
    try {
      window.postMessage(
        JSON.stringify({ type: "OPEN_URL", data: { url } }),
        "*"
      );
      return;
    } catch (e) {
      // fall through to window.open
    }
  }
  window.open(url, "_blank", "noopener,noreferrer");
}
